import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWalletBalanceStore = defineStore('walletBalance', () => {
  const isWalletBalanceDetailsModalOpened = ref<boolean>(false)
  const isWalletBalanceMultipleItemModalOpened = ref<boolean>(false)
  const isWalletBalanceVisible = ref<boolean>(true)

  const showWalletBalanceDetailsModal = () => {
    isWalletBalanceDetailsModalOpened.value = true
  }

  const hideWalletBalanceDetailsModal = () => {
    isWalletBalanceDetailsModalOpened.value = false
  }

  const showWalletBalanceMultipleItemModal = () => {
    isWalletBalanceMultipleItemModalOpened.value = true
  }

  const hideWalletBalanceMultipleItemModal = () => {
    isWalletBalanceMultipleItemModalOpened.value = false
  }

  const toggleWalletBalanceVisibility = () => {
    isWalletBalanceVisible.value = !isWalletBalanceVisible.value
  }

  return {
    isWalletBalanceDetailsModalOpened,
    isWalletBalanceVisible,
    toggleWalletBalanceVisibility,
    showWalletBalanceDetailsModal,
    hideWalletBalanceDetailsModal,
    isWalletBalanceMultipleItemModalOpened,
    showWalletBalanceMultipleItemModal,
    hideWalletBalanceMultipleItemModal
  }
})
